module.exports = __webpack_public_path__ + "static/media/U1-T2-1-2b.913e4b65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-2b.svg
// module id = 519
// module chunks = 0